import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, renderSlot as _renderSlot, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "crm:flex" }

import {computed, onMounted} from 'vue';
import Utilities from "fallco-frontend-framework/src/js/libs/utilities/index.js";
import BaseModal from "fallco-frontend-framework/src/vue/components/layout/BaseModal.vue";
import {useDefineModal} from "../composable/definer/useDefineModal";


export default {
  __name: 'BaseControlModal',
  props: {
  /**
   * messaggio che indica cosa si sta tentando di cancellare
   */
  message: {
    type: String,
    default: ''
  }
},
  emits: [
  /**
   * emitta in caso si clicchi il pulsante di conferma
   */
  'confirm:control',
  /**
   * emitta in caso si clicchi il pulsante di annulla operazione
   */
  'close:control'
],
  setup(__props, { emit: __emit }) {

/**
 * @doc Definisce una modale di controllo (ex. controllo cancellazione)
 */
const props = __props


const emits = __emit

const messages = computed(() => {
  return {
    title: `Vuoi cancellare ${props.message} ?`,
    description: `Confermi la cancellazione?`
  }
})

const modaleDiControllo = useDefineModal(`cancella_${Utilities.generate_random_id()}`, messages.value.title, false);

/**
 * emitta ed esegue la callback di conferma cancellazione
 */
function onConfirm() {
  onClose()
  emits('confirm:control')
}

onMounted(() => {
  modaleDiControllo.open();
})

/**
 * Gestisce la chiusura della modale di controllo
 */
function onClose() {
  modaleDiControllo.close();
  emits('close:control')
}

return (_ctx, _cache) => {
  const _component_base_button = _resolveComponent("base-button")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_unref(modaleDiControllo).getShow())
        ? (_openBlock(), _createBlock(BaseModal, {
            key: 0,
            size: "sm",
            "onModal:closed": _cache[1] || (_cache[1] = $event => (onClose())),
            title: _unref(modaleDiControllo).getTitle(),
            id: _unref(modaleDiControllo).getId()
          }, {
            default: _withCtx(() => [
              _createElementVNode("p", null, _toDisplayString(messages.value.description), 1 /* TEXT */),
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_base_button, {
                  "onClick:cta": _cache[0] || (_cache[0] = $event => (onClose())),
                  class: "crm:mr-2!"
                }, {
                  default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                    _createTextVNode(" Annulla ", -1 /* CACHED */)
                  ]))]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_base_button, {
                  mode: "error",
                  "onClick:cta": onConfirm
                }, {
                  default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                    _createTextVNode(" Conferma ", -1 /* CACHED */)
                  ]))]),
                  _: 1 /* STABLE */
                })
              ])
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["title", "id"]))
        : _createCommentVNode("v-if", true)
    ])),
    _renderSlot(_ctx.$slots, "default")
  ], 64 /* STABLE_FRAGMENT */))
}
}

}